import { useLang } from "@/context/LanguageContext";
import { Reveal, Overline } from "@/components/Reveal";
import { ABOUT_IMG } from "@/lib/assets";

export default function About() {
  const { t } = useLang();
  return (
    <section id="about" data-testid="about-section" className="bg-icdh-white py-28 md:py-40">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-5">
            <Reveal><Overline>{t.about.overline}</Overline></Reveal>
            <Reveal delay={0.1}>
              <h2 className="mt-6 font-serif text-4xl md:text-6xl leading-[1.02] tracking-tight text-icdh-navy">{t.about.title}</h2>
            </Reveal>
            <Reveal delay={0.2}>
              <p className="mt-8 text-icdh-navy/75 text-lg max-w-md">{t.about.lead}</p>
            </Reveal>
            <Reveal delay={0.3}>
              <div className="mt-10 overflow-hidden">
                <img src={ABOUT_IMG} alt="ICDH students" className="w-full aspect-[3/4] object-cover object-top hover:scale-105 transition-transform duration-700" />
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-6 lg:col-start-7">
            <Reveal delay={0.15}>
              <p className="text-icdh-navy/80 leading-relaxed">{t.about.body_1}</p>
            </Reveal>
            <Reveal delay={0.2}>
              <p className="mt-6 text-icdh-navy/80 leading-relaxed">{t.about.body_2}</p>
            </Reveal>
            <Reveal delay={0.25}>
              <p className="mt-6 text-icdh-navy/80 leading-relaxed">{t.about.body_3}</p>
            </Reveal>

            <div className="mt-12 space-y-px">
              {t.about.chapters.map((c, i) => (
                <Reveal key={i} delay={i * 0.1}>
                  <div className="group grid grid-cols-[auto,1fr] gap-8 py-8 border-t border-icdh-navy/15">
                    <span className="font-serif text-4xl md:text-5xl text-icdh-navy/20 group-hover:text-icdh-red transition-colors duration-500 min-w-[5rem]">{c.n}</span>
                    <div>
                      <h3 className="font-sans font-bold text-xl text-icdh-navy tracking-tight">{c.t}</h3>
                      <p className="mt-2 text-icdh-navy/65 text-sm">{c.d}</p>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>

        {/* Stats strip */}
        <div className="mt-20 grid md:grid-cols-3 border-t border-icdh-navy/15" data-testid="about-stats">
          {t.about.stats.map((s, i) => (
            <Reveal key={i} delay={i * 0.08}>
              <div className={`py-10 md:py-12 ${i > 0 ? "md:border-l border-icdh-navy/15" : ""} md:pl-10`}>
                <p className="font-serif text-5xl md:text-6xl text-icdh-red">{s.n}</p>
                <p className="mt-3 text-icdh-navy/70 text-sm uppercase tracking-[0.2em]">{s.t}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
